/**
 * UI_V2 feature flag — controls whether the design-system primitives render
 * their new look-and-feel or fall back to legacy styles.
 *
 * Read priority:
 *   1. localStorage('UI_V2') === 'false'   → off (per-user kill switch)
 *   2. process.env.REACT_APP_UI_V2 === 'false' → off (build-time)
 *   3. default                              → on
 *
 * 30-second rollback: set REACT_APP_UI_V2=false in Emergent env, redeploy.
 */
export function isUIV2() {
  try {
    const ls = typeof window !== 'undefined' ? window.localStorage?.getItem('UI_V2') : null;
    if (ls === 'false') return false;
    if (ls === 'true') return true;
  } catch (_) {
    // localStorage unavailable — fall through to env
  }
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_UI_V2 === 'false') {
    return false;
  }
  return true;
}

if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('data-ui-v2', String(isUIV2()));
}
